import { useState } from "react";
import "../App.css";
import mascot_computer from "../images/mascot_computer.png";
import mascot_maya from "../images/mascot_maya.png";
import mascot_roman from "../images/mascot_roman.png";
import {
  introduction1,
  introduction10,
  introduction11,
  introduction2,
  introduction3,
  introduction4,
  introduction5,
  introduction6,
  introduction7,
  introduction8,
  introduction9,
  introductionTitle,
  lang,
  tutorialButtonNextPage,
  tutorialButtonPreviousPage,
  tutorialButtonStartLevel
} from "../strings";

function Introduction({ show, handleClose }) {

  const [page, setPage] = useState(0); // Which page of the tutorial to display. Think of the tutorial like a book containing text.

  const maxPages = 6; // Note that the first page has index 0. This means maxPages-1 is the last page.

  const handleNext = () => {
    setPage(n => n + 1)
  };

  const handlePrevious = () => {
    setPage(n => n - 1)
  };

  return (
    <div style={{display: (show === 1) ? "flex" : "none"}} className="introduction-wrapper">
      <img src={mascot_roman} style={{position: "absolute", top: "34dvh", left: "10dvh", height: "32dvh", width: "16dvh", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))"}}/>
      <img src={mascot_maya} style={{position: "absolute", top: "34dvh", right: "10dvh", height: "32dvh", width: "16dvh", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))"}}/>
      <img src={mascot_computer} style={{position: "absolute", bottom: "5dvh", right: "50%", height: "24dvh", width: "24dvh", transform: "translateX(50%)", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))"}}/>
      <div className="introduction-title">
        {introductionTitle}
      </div>
      <div className="introduction-body">
        {page === 0 && 
          <div>
            {introduction1}
            <br></br>&nbsp;<br></br>
            {introduction2}
          </div>
        }
        {page === 1 && 
          <div>
            {introduction3}
            <br></br>&nbsp;<br></br>
            {introduction4}
          </div>
        }
        {page === 2 && 
          <div>
            {introduction5}
            <br></br>&nbsp;<br></br>
            {introduction6}
          </div>
        }
        {page === 3 && 
          <div>
            {introduction7}
          </div>
        }
        {page === 4 && 
          <div>
            {introduction8}
            <br></br>&nbsp;<br></br>
            {introduction9}
          </div>
        }
        {page === 5 && 
          <div>
            {introduction10}
            <br></br>&nbsp;<br></br>
            {introduction11}
          </div>
        }
      </div>
      <div className="introduction-button-section">
        {/* Button to start level. */}
        {page === (maxPages-1) && 
          <button
            onClick={handleClose}
            className="introduction-next-button"
            style={{fontSize: lang=== 1 ? "3dvh" : undefined}} // Decrease font size for German language.
          >
          {tutorialButtonStartLevel}
          </button>
        }

        {/* Button to go to previous page. */}
        {page > 0 && 
          <button
            onClick={handlePrevious}
            className="introduction-previous-button"
          >
          {tutorialButtonPreviousPage}
          </button>
        }

        {/* Button to go to next page. */}
        {page < (maxPages-1) && 
          <button
            onClick={handleNext}
            className="introduction-next-button"
          >
          {tutorialButtonNextPage}
          </button>
        }
      </div>
    </div>
  );
}

export default Introduction;
